import React from 'react';

import styles from './Phone.module.scss';

const Phone = ({ phoneNumber, phoneStyleName }) => {
  return (
    <span className={`text-nowrap ${phoneStyleName}`}>
      <span
        className={`${
          phoneStyleName === 'inherited-color'
            ? styles['phone-number-inherited-color']
            : styles['phone-number']
        } visible-xs-inline`}
      >
        {phoneNumber}
      </span>
      <a
        href={`tel:${phoneNumber}`}
        className={`${styles['phone-number-mobile']} visible-xs-inline`}
      >
        {phoneNumber}
      </a>
    </span>
  );
};

export default Phone;
